// Vendor imports
const { combineReducers } = require('redux-immutable')
// Common imports
const commonStateReducers = require('client-v2/common/state/reducers')
// Entry imports
const RootRecord = require('./record')

const reducers = Object.assign({}, commonStateReducers, {
  // Common container reducers
  articleProfile: require('client-v2/common/containers/article-profile/state/slide-reducer'),
  articleProfileModal: require('client-v2/common/containers/article-profile/state/modal-reducer'),
  authModal: require('client-v2/common/containers/auth-modal/reducer')
})

module.exports = combineReducers(
  reducers,
  () => new RootRecord()
)
